export const SHOW_MULTI_PDP_VISITS = 'SHOW_MULTI_PDP_VISITS';
export const SHOW_PDP_SOURCING = 'SHOW_PDP_SOURCING';

export const PRIORITIES = {
    MULTI_PDP_VISITS: 345,
    PDP_SOURCING: 450,
};

export const NOTIFICATION_KEYS = {
    MULTI_PDP_VISITS: 'multiPdpVisits',
    PDP_SOURCING_MODAL: 'pdpSourcingModal',
};
